import { Box, CircularProgress } from '@mui/material';
import { useAppSelector } from '../../Redux/hooks';
import styled, { keyframes } from 'styled-components';

// Define keyframes
const rotate = keyframes`
  to {
    transform: rotate(0.5turn);
  }
`;

// Styled component
const Loader = styled.div`
  width: 50px;
  aspect-ratio: 1;
  --_c: no-repeat radial-gradient(farthest-side, #215fb0 92%, #0000);
  background: 
    var(--_c) top,
    var(--_c) left,
    var(--_c) right,
    var(--_c) bottom;
  background-size: 12px 12px;
  animation: ${rotate} 1s infinite;
`;
const LoaderOverlay = () => {
  const loading = useAppSelector((state) => state.loader.loading);

  if (!loading) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 1300,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(11, 10, 10, 0.32)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Loader/>
    </Box>
  );
};

export default LoaderOverlay;
